/**
 * Normalizes a connector type by stripping the `platform-` prefix if present.
 *
 * Some connector types are prefixed with `platform-` (e.g., `platform-google-drive-connector`)
 * but should be reported in analytics without this prefix (e.g., `google-drive-connector`).
 */
export const normalizeConnectorType = (connectorType: string | undefined): string | undefined => {
  if (!connectorType) {
    return connectorType;
  }

  return connectorType.startsWith('platform-') ? connectorType.slice('platform-'.length) : connectorType;
};
